import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { sendCancelRequest } from "../../../redux/slices/customer/paymentsSlice";
import showAlert from '../../../components/common/showAlert';
const CancelSubscriptionMessageModal = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();
  const exercises_min = useSelector((state) => state.app_options?.exercises_min);
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!isOpen) {
      setMessage("");
    }
  }, [isOpen]);

  const handleSave = (e) => {
      e.preventDefault();      
      dispatch(sendCancelRequest({message:message}));
      onClose();      
      showAlert('success', 'We have received your request, we will get back to you soon');
  };

  return isOpen ? (
    <div
      className="modal fade show replace-exercise-modal"
      style={{ display: "block" }}
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header justify-content-center">
            <h5 className="modal-title">Contact AGC About Your Subscription</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
 
              <div className="w-100 mt-4">
                <textarea
                id="message"
                rows="15"
                placeholder="Message Us"
                onChange={(e) => setMessage(e.target.value)}
                className="form-control"
                value={message}
              />
              </div>
              <div className="form-group mb-0 mt-4">
                <button
                  onClick={handleSave}
                  className="btn-curve w-100"
                >
                  Send
                </button>
              </div>
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

export default CancelSubscriptionMessageModal;